import React from "react";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import {
    StepsSection as StepsSectionStyled,
    SectionHeader,
    UnderlineGraphic,
    StepsCardsWrapper,
    StepCardContent,
    StepNumberBadge,
    StepIconWrapper,
    StepIcon,
    StepTextWrapper,
} from "./styles";
import { StepCardData } from "./types";

interface StepsSectionProps {
    stepsData: StepCardData[];
    onReferNowClick: () => void;
}

export const StepsSection: React.FC<StepsSectionProps> = ({ stepsData, onReferNowClick }) => {
    return (
        <StepsSectionStyled>
            <SectionHeader>
                <UnderlineGraphic>
                    <Text variant="V2.body1.neutral.bold" style={{ opacity: 0.7, color: "#3A8466" }}>
                        Get referral money in just
                    </Text>
                    <svg xmlns="http://www.w3.org/2000/svg" width="134" height="6" viewBox="0 0 134 6" fill="none">
                        <path
                            opacity="0.6"
                            d="M0.75 0.75L129.931 0.75C135.396 1.25 135.359 1.25 107.04 4.75"
                            stroke="#3A8466"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </UnderlineGraphic>
                <Text variant="V2.hero.neutral.black" color="positive">
                    4 Easy Steps
                </Text>
            </SectionHeader>

            <StepsCardsWrapper>
                {stepsData.map((step) => (
                    <StepCardContent key={step.id}>
                        <StepNumberBadge>
                            <Text variant="V2.heading2.neutral.bold" color="background_Primary">
                                {step.step}
                            </Text>
                        </StepNumberBadge>
                        <StepIconWrapper>
                            <StepIcon as="img" src={step.icon} alt="" />
                        </StepIconWrapper>
                        <StepTextWrapper>
                            <Text variant="V2.body2.neutral.medium" color="text_Med_Emphasis">
                                {step.description}
                            </Text>
                        </StepTextWrapper>
                    </StepCardContent>
                ))}
            </StepsCardsWrapper>

            <div style={{ width: "220px", marginTop: "38px", marginBottom: "50px" }}>
                <FullWidthButton
                    variant="positive"
                    onClick={onReferNowClick}
                    style={{
                        borderRadius: "40px",
                        backgroundColor: "#4E9176",
                        height: "48px",
                    }}
                >
                    Refer Now
                </FullWidthButton>
            </div>
        </StepsSectionStyled>
    );
};
